//
// Copyright (c) Microsoft. All rights reserved.
// Licensed under the MIT license. See LICENSE.md file in the project root for full license information.
//

import { InterimResults } from "./InterimResultsMode";

/**
 * The language id output configuration
 */
export interface LanguageIdOutput {
    /**
     * The interim results configuration
     */
    interimResults?: InterimResults;
}
